export default __webpack_public_path__ + "static/media/msf_background_s1.e79ab84a.jpg";